import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import * as actions from './actions'
import * as mutations from './mutations'
import state from './state'

import users from './users'
import appointments from './appointments'
import families from './families'
import students from './students'
import tutors from './tutors'
import agreements from './agreements'
import student_tutors from './student_tutors'
import documents from './documents'

Vue.use(Vuex)

const store = new Vuex.Store({
  getters,
  actions,
  mutations,
  state,
  modules: {
    users,
    appointments,
    families,
    students,
    tutors,
    agreements,
    student_tutors,
    documents
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js